import {
    default as actions,
    GET_TOKEN,
    GET_URL
} from './action';

const defaultState = {
    tokenModel: {
    },
    urlModel: {
    }
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case GET_URL:
            return Object.assign({}, state, {
                tokenModel: action.payload
            });
        case GET_TOKEN:
            return Object.assign({}, state, {
                urlModel: action.payload
            });
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};